import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  assetTypes: [],
  assetMapping: {}
};

export const assetType = createSlice({
  name: 'assetTypeList',
  initialState,
  reducers: {
    setAssetType: (state, action) => {
      state.assetTypes = action?.payload;
    },

    setAssetMapping: (state, action) => {
      state.assetMapping = action?.payload;
    }
  }
});

export const { setAssetType, setAssetMapping } = assetType?.actions;

export default assetType?.reducer;
